import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import './NewsSingleSkeleton.scss';
import React from 'react';

export const NewsSingleSkeleton = () => (
  <div className="NewsSingle">
    <div className="newsContent">
      <Skeleton>
        <SkeletonItem shape="rectangle" className="skeletonTitle" />
        <SkeletonItem shape="rectangle" className="skeletonDate" />
        <SkeletonItem shape="rectangle" className="skeletonDescriptionLine1" />
        <SkeletonItem shape="rectangle" className="skeletonDescriptionLine2" />
      </Skeleton>
    </div>
  </div>
);
